import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Eraser } from '../../icons';
import { IconButton } from '../material-ui/IconButton';
import { useStyles } from './useStyles';
import { useHookWithRefCallback } from './tools';
import { useDarkTheme } from '../../selectors/screen';

export const SignaturePad = memo(({ onClear, onInitSignature }) => {
    const isDarkTheme = useDarkTheme();
    const classes = useStyles({ isDarkTheme });
    const { t: translate } = useTranslation();

    const [signatureRef] = useHookWithRefCallback(onInitSignature, isDarkTheme);

    return (
        <div className={classes.wrapper}>
            <canvas id="signature-pad" className={classes.canvas} ref={signatureRef}></canvas>
            <IconButton tooltip={translate('clear')} onClick={onClear} className={classes.eraseBtn}>
                <Eraser />
            </IconButton>
        </div>
    );
});
